export const UPLOAD_PROFILE_IMAGE = 'profileImage.UPLOAD_PROFILE_IMAGE'
export const UPDATE_PROFILE_IMAGE = 'profileImage.UPDATE_PROFILE_IMAGE'
export const DELETE_PROFILE_IMAGE = 'profileImage.DELETE_PROFILE_IMAGE'

export const uploadProfileImage = (id, file, callback) => ({
  type: UPLOAD_PROFILE_IMAGE, id, file, callback,
})
export const updateProfileImage = (id, file, callback) => ({
  type: UPDATE_PROFILE_IMAGE, id, file, callback,
})
export const deleteProfileImage = (id, callback) => ({
  type: DELETE_PROFILE_IMAGE, id, callback,
})
